export interface TestScenario {
  id: string
  name: string
  description: string
  event: any // Using any for compatibility with the demo page
}

export const testScenarios: Record<string, TestScenario> = {
  completed: {
    id: 'completed',
    name: 'הושלם',
    description: 'האירוע הושלם בהצלחה',
    event: {
      id: "EVT-2024-001",
      type: "תקר בגלגל",
      location: "רחוב הרצל 45, תל אביב",
      status: "completed",
      volunteer: {
        eta: 8,
        branch: "ירושלים",
        eventsCompleted: 89,
      },
      createdAt: new Date(Date.now() - 45 * 60 * 1000),
      updatedAt: new Date(Date.now() - 5 * 60 * 1000),
      description: "תקר בגלגל קדמי ימני, הרכב חונה בצד הדרך",
      statusHistory: [
        { status: "opened", timestamp: new Date(Date.now() - 45 * 60 * 1000) },
        { status: "assigned", timestamp: new Date(Date.now() - 40 * 60 * 1000) },
        { status: "en_route", timestamp: new Date(Date.now() - 35 * 60 * 1000) },
        { status: "arrived", timestamp: new Date(Date.now() - 20 * 60 * 1000) },
        { status: "completed", timestamp: new Date(Date.now() - 5 * 60 * 1000) },
      ],
      eventPhotos: ["/placeholder.jpg"],
    }
  },
  opened: {
    id: 'opened',
    name: 'נפתח',
    description: 'קריאה חדשה שנפתחה',
    event: {
      id: "EVT-2024-002",
      type: "תקר בגלגל",
      location: "רחוב הרצל 45, תל אביב",
      status: "opened",
      volunteer: undefined,
      createdAt: new Date(Date.now() - 5 * 60 * 1000),
      updatedAt: new Date(Date.now() - 5 * 60 * 1000),
      description: "תקר בגלגל קדמי ימני, הרכב חונה בצד הדרך",
      statusHistory: [
        { status: "opened", timestamp: new Date(Date.now() - 5 * 60 * 1000) },
      ],
      eventPhotos: ["/placeholder.jpg"],
    }
  },
  assigned: {
    id: 'assigned',
    name: 'הוקצה מתנדב',
    description: 'מתנדב הוקצה לטיפול',
    event: {
      id: "EVT-2024-003",
      type: "תקר בגלגל",
      location: "רחוב הרצל 45, תל אביב",
      status: "assigned",
      volunteer: {
        eta: 15,
        branch: "ירושלים",
        eventsCompleted: 89,
      },
      createdAt: new Date(Date.now() - 10 * 60 * 1000),
      updatedAt: new Date(Date.now() - 5 * 60 * 1000),
      description: "תקר בגלגל קדמי ימני, הרכב חונה בצד הדרך",
      statusHistory: [
        { status: "opened", timestamp: new Date(Date.now() - 10 * 60 * 1000) },
        { status: "assigned", timestamp: new Date(Date.now() - 5 * 60 * 1000) },
      ],
      eventPhotos: ["/placeholder.jpg"],
    }
  },
  en_route: {
    id: 'en_route',
    name: 'בדרך',
    description: 'המתנדב בדרך אליך',
    event: {
      id: "EVT-2024-004",
      type: "תקר בגלגל",
      location: "רחוב הרצל 45, תל אביב",
      status: "en_route",
      volunteer: {
        eta: 8,
        branch: "ירושלים",
        eventsCompleted: 89,
      },
      createdAt: new Date(Date.now() - 20 * 60 * 1000),
      updatedAt: new Date(Date.now() - 2 * 60 * 1000),
      description: "תקר בגלגל קדמי ימני, הרכב חונה בצד הדרך",
      statusHistory: [
        { status: "opened", timestamp: new Date(Date.now() - 20 * 60 * 1000) },
        { status: "assigned", timestamp: new Date(Date.now() - 15 * 60 * 1000) },
        { status: "en_route", timestamp: new Date(Date.now() - 10 * 60 * 1000) },
      ],
      eventPhotos: ["/placeholder.jpg"],
    }
  },
  arrived: {
    id: 'arrived',
    name: 'הגיע למקום',
    description: 'המתנדב הגיע ומטפל',
    event: {
      id: "EVT-2024-005",
      type: "תקר בגלגל",
      location: "רחוב הרצל 45, תל אביב",
      status: "arrived",
      volunteer: {
        eta: 0,
        branch: "ירושלים",
        eventsCompleted: 89,
      },
      createdAt: new Date(Date.now() - 30 * 60 * 1000),
      updatedAt: new Date(Date.now() - 1 * 60 * 1000),
      description: "תקר בגלגל קדמי ימני, הרכב חונה בצד הדרך",
      statusHistory: [
        { status: "opened", timestamp: new Date(Date.now() - 30 * 60 * 1000) },
        { status: "assigned", timestamp: new Date(Date.now() - 25 * 60 * 1000) },
        { status: "en_route", timestamp: new Date(Date.now() - 20 * 60 * 1000) },
        { status: "arrived", timestamp: new Date(Date.now() - 5 * 60 * 1000) },
      ],
      eventPhotos: ["/placeholder.jpg"],
    }
  }
}

export function getScenario(scenarioKey: string): any {
  return testScenarios[scenarioKey]?.event || testScenarios.completed.event
}

export function getScenarioKeys(): string[] {
  return Object.keys(testScenarios)
}

export const scenarioLabels: Record<string, string> = {
  completed: 'הושלם',
  opened: 'נפתח',
  assigned: 'הוקצה מתנדב',
  en_route: 'בדרך',
  arrived: 'הגיע למקום'
}

export type Event = any // For compatibility with scenario-selector
